
export { default as DifficultyIcon } from "./components/DifficultyIcon"
export { getTrailDifficultyFromNumber } from "/app/packages/trails/src/utils/trailDifficultyHelpers.ts"
export { getTrailDifficultyLabel } from "/app/packages/trails/src/utils/trailDifficultyHelpers.ts"